module.exports = __webpack_public_path__ + "static/media/france_est.d70d605c.svg";